module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.3326e4d7.woff2";